<div class="atlas-form mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-start mct-items-center mct-gap-28"    >
  <div style="width: 550px; flex-shrink: 0;">
    <label>{{ 'news-articles.search.name' | translate | titlecase }}</label>
    <input [(ngModel)]="searchParams.Name" [placeholder]="'news-articles.search.name-placeholder' | translate | ucfirst" type="text" />
  </div>
  <div class="mct-flex mct-row mct-gap-10"  >
    <div class="mct-flex mct-col" >
      <label>{{ 'news-articles.search.article-date' | translate | titlecase }}</label>
      <wl-date-selector [(ngModel)]="searchParams.ArticleDateStart"></wl-date-selector>
    </div>
    <div  class="mct-flex pb-3 mct-justify-start mct-items-end">
      <label>{{ 'common.through' | translate }}</label>
    </div>
    <div class="mct-flex mct-justify-start mct-items-end" >
      <wl-date-selector [(ngModel)]="searchParams.ArticleDateEnd"></wl-date-selector>
    </div>
  </div>
</div>
